import axios from "axios";
import comm from "csi/comm";

// Never export this key.
const SECRET_KEY = "62x5zD8398N9EKDhmUe4jkuzpWLgX";

function mergeData(mergedData: ArrayBuffer, buffer: ArrayBuffer): ArrayBuffer {
	var tmp = new Uint8Array(mergedData.byteLength + buffer.byteLength);
	tmp.set(new Uint8Array(mergedData), 0);
	tmp.set(new Uint8Array(buffer), mergedData.byteLength);
	mergedData = tmp.buffer;
	return mergedData;
}

function generateAESKeyFromHardcodedValue(): Promise<CryptoKey> {
	const encoder = new TextEncoder();
	const keyBytes = encoder.encode(SECRET_KEY);
	// Ensure the key is 128 bits (16 bytes)
	const paddedKeyBytes = new Uint8Array(16);
	paddedKeyBytes.set(keyBytes.slice(0, 16), 0); 
	return crypto.subtle.importKey(
	  "raw",
	  paddedKeyBytes,
	  { name: "AES-CTR" },
	  true, // Make the key extractable
	  ["encrypt", "decrypt"],
	);
}

async function deriveNonce(key: CryptoKey, chunkNumber: number): Promise<Uint8Array> {
	const encoder = new TextEncoder();
	const data = encoder.encode(new TextDecoder()
		.decode(await crypto.subtle.exportKey("raw", key)) +
	  chunkNumber.toString());		  
	const hashBuffer = await crypto.subtle.digest("SHA-256", data);
	const nonce = new Uint8Array(hashBuffer)
		.slice(0, 16);	  
	return nonce;
}

async function decryptChunk(encryptedData: ArrayBuffer | string, chunkNumber: number): Promise<ArrayBuffer> {
	const encryptionKey = await generateAESKeyFromHardcodedValue();
	const nonce = await deriveNonce(encryptionKey, chunkNumber);
	const algorithm = {
	  name: "AES-CTR",
	  counter: nonce,
	  length: 64,
	};	  
	const decryptedData = await crypto.subtle.decrypt(
	  algorithm,
	  encryptionKey,
	  encryptedData as BufferSource,
	);		  
	return decryptedData;
}	

export async function decryptFileChunks(fileChunks: string) : Promise<ArrayBuffer | undefined> {
	let mergedData = new ArrayBuffer(0);
	const chunkUrls: string[] = JSON.parse(fileChunks).chunkUrls;
	if (chunkUrls && chunkUrls.length > 0) {
		const loadedChunks = [] ;
		// Loop through the chunkUrls array
		const promises = chunkUrls.map((chunkUrl, index) => {
			return new Promise<void>((resolve, reject) => {
				const chunkRequest = comm.getFileRequest(chunkUrl)
					.toRequest();		
				// Load the chunk
				axios.get(chunkRequest, { responseType: "arraybuffer" })
					.then(async (response) => {
						try {
							const decryptedData = await decryptChunk(response.data, index);
							// Save decrypted data in loadedChunks in correct order
							loadedChunks[index] = decryptedData;
							resolve();
						} catch (error) {
							console.error("Error decrypting data:", error);
							reject(error);
						}						
					});
			});
		});

		try {
			await Promise.all(promises);
			// Merge the decrypted data chunks
			loadedChunks.forEach((chunk) => {
				mergedData = mergeData(mergedData, chunk);
			});
			return mergedData;
		} catch (error) {
			console.error("Error decrypting data:", error);
		}
	}
}